import { render, staticRenderFns } from "./RowUom.vue?vue&type=template&id=56395405&"
import script from "./RowUom.vue?vue&type=script&lang=js&"
export * from "./RowUom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports